import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "asNotifications" }
const _hoisted_2 = { class: "asNotifications_title" }
const _hoisted_3 = { class: "asNotifications_content" }
const _hoisted_4 = {
  key: 0,
  class: "asNotifications_item"
}
const _hoisted_5 = { class: "asNotifications_label" }
const _hoisted_6 = { class: "asNotifications_item" }
const _hoisted_7 = { class: "asNotifications_label" }
const _hoisted_8 = { class: "asNotifications_item" }
const _hoisted_9 = { class: "asNotifications_label" }
const _hoisted_10 = { class: "asNotifications_item" }
const _hoisted_11 = { class: "asNotifications_label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mq_responsive = _resolveComponent("mq-responsive")!
  const _component_as_switch = _resolveComponent("as-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_mq_responsive, { target: "desktop" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('notificationSettings')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isShowPushSubscribeBtn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('siteNotifications')), 1),
            _createVNode(_component_as_switch, {
              modelValue: _ctx.isPushSubcribed,
              "onUpdate:modelValue": _ctx.togglePushSubscribe
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('emailNotifications')), 1),
        _createVNode(_component_as_switch, {
          loading: _ctx.isSendingEmail,
          modelValue: _ctx.isEmailSubcribed,
          "onUpdate:modelValue": _ctx.toggleEmailSubscribe
        }, null, 8, ["loading", "modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('smsNotifications')), 1),
        _createVNode(_component_as_switch, {
          modelValue: _ctx.isSmsSubscribed,
          "onUpdate:modelValue": _ctx.toggleSmsSubscribe
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('whatsappNotifications')), 1),
        _createVNode(_component_as_switch, {
          modelValue: _ctx.isWhatsappSubscribed,
          "onUpdate:modelValue": _ctx.toggleWhatsappSubscribe
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ])
    ])
  ]))
}